<template>
  <div class="kk-rightpanel__container" :class="{ 'kk-panel__container-invisible': false }">
    <div class="kk-rightpanel" :class="{ 'kk-rightpanel-toggle-width': false }">
      <sub-navigation />
      <main-navigation />
    </div>
  </div>
</template>

<script>
import MainNavigation from "./spots/BlueZoneSpots.vue";
import SubNavigation from "./content/BlueZoneContent.vue";
export default {
  components: {
    MainNavigation,
    SubNavigation,
  },

  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.kk-rightpanel {
  display: flex;
  width: 320px;

  &-toggle-width {
    width: 3.3rem !important;
  }

  &__container {
    display: flex;
    position: relative;
    height: calc(100vh - 6rem);

    &-invisible {
      padding-left: 0px; /* desired padding */
    }
  }
}
</style>
